import {Component, model} from '@angular/core';
import {DropdownFilterComponent} from '../../../../../shared/components/filter/dropdown-filter/dropdown-filter.component';
import {SUBMISSION_DATE_FILTER_ALL} from './dropdown-submission-date-filter.types';

@Component({
  selector: 'app-dropdown-submission-date-filter',
  templateUrl: './dropdown-submission-date-filter.component.html',
  imports: [DropdownFilterComponent],
})
export class DropdownSubmissionDateFilterComponent {
  value = model.required<number>();

  protected readonly options: {label: string; value: number}[] = [
    {label: 'common.all', value: SUBMISSION_DATE_FILTER_ALL},
    {label: '10 Tage', value: 10},
    {label: '5 Tage', value: 5},
    {label: '3 Tage', value: 3},
  ];
}
